"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStyles = getStyles;
var Styling_1 = require("../../../../Styling");
var SuggestionsItem_styles_1 = require("../../Suggestions/SuggestionsItem.styles");
var GlobalClassNames = {
    root: 'ms-PeoplePicker-personaContent',
    personaWrapper: 'ms-PeoplePicker-Persona',
};
function getStyles(props) {
    var _a, _b, _c;
    var className = props.className, theme = props.theme;
    var classNames = (0, Styling_1.getGlobalClassNames)(GlobalClassNames, theme);
    var textSelectorsStyles = {
        selectors: (_a = {},
            _a[".".concat(SuggestionsItem_styles_1.SuggestionsItemGlobalClassNames.isSuggested, " &")] = {
                selectors: (_b = {},
                    _b[Styling_1.HighContrastSelector] = {
                        color: 'HighlightText',
                    },
                    _b),
            },
            _a[".".concat(classNames.root, ":hover &")] = {
                selectors: (_c = {},
                    _c[Styling_1.HighContrastSelector] = {
                        color: 'HighlightText',
                    },
                    _c),
            },
            _a),
    };
    return {
        root: [
            classNames.root,
            {
                width: '100%',
                padding: '4px 12px',
            },
            className,
        ],
        personaWrapper: [
            classNames.personaWrapper,
            {
                width: 180,
            },
        ],
        subComponentStyles: {
            persona: {
                primaryText: textSelectorsStyles,
                secondaryText: textSelectorsStyles,
            },
        },
    };
}
//# sourceMappingURL=PeoplePickerItemSuggestion.styles.js.map